import { uploadUrl } from "../../lib/assets";

/**
 * @param {{ story: import("../../data/stories").STORIES[0], featured?: boolean, onOpen: (id: string) => void, index: number }} props
 */
export default function StoryHeroCard({ story, featured = false, onOpen, index }) {
  return (
    <article
      className="stories-hero-card"
      style={{ animationDelay: `${index * 0.08}s` }}
      onClick={() => onOpen(story.id)}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          onOpen(story.id);
        }
      }}
      role="button"
      tabIndex={0}
      aria-label={`Read story: ${story.title}`}
    >
      <div className={`stories-hero-card__frame${featured ? " stories-hero-card__frame--featured" : ""}`}>
        <div
          className="stories-hero-card__image"
          style={{ backgroundImage: `url('${uploadUrl(story.img)}')` }}
        />
        <div className="stories-hero-card__scrim" />

        <div className="stories-hero-card__content">
          <div className="stories-hero-card__content-inner">
            <div className="stories-hero-card__meta">
              {story.cat ? (
                <>
                  <span>{story.cat.toUpperCase()}</span>
                  <span className="stories-hero-card__meta-rule" />
                </>
              ) : null}
              <span>{story.date}</span>
            </div>

            <h2 className={`stories-hero-card__title${featured ? " stories-hero-card__title--featured" : ""}`}>
              {story.title}
            </h2>

            <p className="stories-hero-card__dek">{story.dek}</p>

            <div className="stories-hero-card__cta">
              READ STORY <span aria-hidden="true">→</span>
              {story.read ? <span className="stories-hero-card__read-time">{story.read}</span> : null}
            </div>
          </div>
        </div>
      </div>
    </article>
  );
}
